export default __webpack_public_path__ + "static/media/Double-curved Hyrkanian Bow.8c2aa6f2.jpg";